module.exports = __webpack_public_path__ + "static/img/logo23.4c0a1c67.png";